import { useState, useCallback, useMemo } from "react";

export default function useShowMore(length: number, max: number) {
	const [expanded, setExpanded] = useState<boolean>(false);
	const [currentLength, setCurrentLength] = useState<number>(max);
	const maxLength = useMemo(() => {
		return max;
	}, [max]);

	// toggle full length and max length
	const showMore = useCallback(() => {
		if (currentLength === maxLength) {
			setCurrentLength(length);
			setExpanded(true);
		} else {
			setCurrentLength(maxLength);
			setExpanded(false);
		}
	}, [currentLength, length, maxLength]);

	return { expanded, maxLength, currentLength, showMore };
}
